import React from "react";
import { Photographers } from "../photographer";
import { PhotographerBasicProfile } from "./photographerBasicProfile";
import { Link} from "react-router-dom";
import { useLocation } from "react-router-dom";
export function PhotographerEditProfile() {
  const location = useLocation();
  const userId = location.state?.id;
  console.log("userId", userId);
  return (
    <div className="matchMainContainer">
      <div className="matchEdit-subcontainer">
        <Link to="/photographers">
        <div
          className="bi bi-arrow-left"
         
        ></div>
        </Link>
        
        <div className="matchBasic-menu">
          <div>Basic Information</div>
        </div>
      </div>
      <div>
        <PhotographerBasicProfile userId={userId} />
      </div>
    </div>
  );
}
